import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Circuit } from "../../Itinerary/objects/circuit";

export type CircuitSliceState = {
    package: {
        data: Circuit | null,
    },
}

const initialState: CircuitSliceState = {
    package: {
        data: null,
    }
}

const slice = createSlice({
    name: 'circuit',
    initialState,
    reducers: {
        setPackage<K extends keyof CircuitSliceState['package']>(
            state: CircuitSliceState,
            action: PayloadAction<{
                key: K,
                value: CircuitSliceState['package'][K],
            }>
        ): void {
            state.package[action.payload.key] = action.payload.value;
        }
    }
});

export default slice;

export const setPackage = slice.actions.setPackage as <
    K extends keyof CircuitSliceState['package'],
>(payload: {
    key: K,
    value: CircuitSliceState['package'][K],
}) => PayloadAction<{
    key: K,
    value: CircuitSliceState['package'][K],
}>;
